import React from 'react';
import UniversalSkeleton from './skeletons/UniversalSkeleton';
import './SkeletonManager.css';

function SkeletonManager({ active , fullWidth = false}) {
  // Only needs active prop - no other configuration needed
  if (!active) return null;

  return (
    <div className="skeleton-wrapper overlay">
      <UniversalSkeleton fullWidth={fullWidth} />
    </div>
  );
}

export default SkeletonManager;